let save: (save_blob: Blob, save_file_name: string) => void;

export function saveAs(blob: Blob, file_name: string): void {
	if (!save) {
		save = (function () {
			const a = document.createElement("a");
			a.setAttribute("style", "display:none");
			document.body.appendChild(a);

			return function (save_blob: Blob, save_file_name: string) {
				const url = window.URL.createObjectURL(save_blob);
				a.href = url;
				(<any>a).download = save_file_name;
				a.click();
				window.URL.revokeObjectURL(url);
			};
		})();
	}
	save(blob, file_name);
};
